import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { RemoveCircleIcon as o } from "../Icons/circle/RemoveCircleIcon.js";
import { tv as i } from "../tailwind-variants.config.js";
const a = i({
  base: "jm-flex jm-w-full jm-bg-white jm-group jm-border-none jm-cursor-pointer jm-select-none jm-text-left jm-items-center jm-gap-2 jm-text-wrap jm-rounded-md jm-p-2 jm-outline jm-outline-none focus-visible:jm-outline-4 focus-visible:-jm-outline-offset-4 focus-visible:jm-outline-jutro-new-blue-500 disabled:jm-cursor-default disabled:jm-pointer-events-none",
  variants: {
    selected: {
      true: "jm-bg-blue-50 hover:jm-bg-jutro-new-blue-100 active:jm-bg-jutro-new-blue-300 disabled:jm-bg-jutro-new-warm-gray-50",
      false: "hover:jm-bg-jutro-new-blue-50 active:jm-bg-jutro-new-blue-100"
    }
  },
  defaultVariants: {
    selected: !1
  }
}), b = (r) => {
  const { option: e, selected: m = !0, disabled: j, onRemove: l } = r, s = () => {
    m && l && l(e);
  };
  return /* @__PURE__ */ n(
    "button",
    {
      className: a({ selected: m }),
      disabled: j,
      onClick: s,
      type: "button",
      children: [
        /* @__PURE__ */ n("div", { className: "jm-flex jm-w-full jm-gap-2 jm-text-jutro-new-warm-gray-800", children: [
          e.leftElement && /* @__PURE__ */ t("span", { className: "jm-grid jm-max-h-6 jm-w-fit jm-place-items-center", children: e.leftElement }),
          /* @__PURE__ */ t("span", { className: "jm-font-paragraph-1 jm-line-clamp-2 jm-w-full", children: e.label }),
          e.rightElement && /* @__PURE__ */ t("span", { className: "jm-grid jm-max-h-6 jm-w-fit jm-place-items-center", children: e.rightElement })
        ] }),
        m && l && /* @__PURE__ */ t("div", { className: "jm-flex jm-items-center jm-justify-center jm-text-jutro-new-blue-800 group-disabled:jm-text-jutro-new-warm-gray-400", children: /* @__PURE__ */ t(o, { size: "sm" }) })
      ]
    }
  );
};
export {
  b as MenuItem
};
//# sourceMappingURL=MenuItem.js.map
